<template>
  <div class="slide-title-wrapper">
    <h2 class="slide-title"><slot /></h2>
  </div>
</template>

<script>
export default {};
</script>

<style scoped>
.slide-title {
  font-size: 20px;
  font-weight: 600;
}
</style>
